'use client';

import { memo } from 'react';

import { Heading, Stack, StackProps } from '@chakra-ui/react';

import { Text } from 'ui/Text';

interface MultiStepHeaderProps extends StackProps {
  title: string;
  subTitle?: string;
  headingColor: string;
  descriptionColor?: string;
  descriptionPX?: { [key: string]: string };
}

const MultiStepHeader = ({
  title,
  subTitle,
  headingColor,
  descriptionColor,
  descriptionPX = {},
  ...props
}: MultiStepHeaderProps) => (
  <Stack
    maxW={{ base: '360px', sm: '900px' }}
    mx='auto'
    gap={{ base: '16px', md: '20px' }}
    mt='40px'
    {...props}
  >
    <Heading
      textStyle='h1'
      as='h1'
      fontWeight='semibold'
      color={headingColor}
      fontSize={[22, 24, 28]}
      textAlign='center'
    >
      {title}
    </Heading>

    {Boolean(subTitle) && (
      <Text
        textAlign='center'
        color={descriptionColor}
        fontSize={{ base: '17px', md: '18px' }}
        lineHeight='160%'
        width='full'
        mx='auto'
        px={descriptionPX}
        whiteSpace='pre-line'
      >
        {subTitle}
      </Text>
    )}
  </Stack>
);

export default memo(MultiStepHeader);
